/* Market City Pharmacy - QA fixes JS (development theme only). Loaded via layout/theme.liquid. */
(function () {
function initVendorLink() {
var v = document.querySelector('.main_product_vendor');
if (!v || v.querySelector('a')) return;
var name = (v.textContent || '').trim();
if (!name) return;
var a = document.createElement('a');
a.href = '/collections/vendors?q=' + encodeURIComponent(name);
a.className = 'qa-vendor-link';
a.setAttribute('aria-label', 'View all products by ' + name);
a.textContent = name;
v.textContent = '';
v.appendChild(a);
}
function init() {
try { initVendorLink(); } catch (e) {}
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* Row 17 - keep the Shop mega menu open while the cursor moves around (hover-intent + close delay) */
(function () {
function bind(li) {
var timer;
li.addEventListener('mouseenter', function () { clearTimeout(timer); li.classList.add('qa-menu-open'); });
li.addEventListener('mouseleave', function () { clearTimeout(timer); timer = setTimeout(function () { li.classList.remove('qa-menu-open'); }, 280); });
}
function setupMegaMenu() {
var items = document.querySelectorAll('.has_mega_menu');
for (var i = 0; i < items.length; i++) { bind(items[i]); }
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setupMegaMenu); } else { setupMegaMenu(); }
})();

/* Row 17 (mobile) - tapping the whole parent bar (e.g. Shop) toggles its dropdown instead of navigating */
(function () {
function bindMobileParent(a) {
var d = a.closest('details');
if (!d) return;
a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); d.open = !d.open; });
}
function setupMobileParents() {
var links = document.querySelectorAll('.mobile_menu_drawer_main_content .mob_parent_a');
for (var i = 0; i < links.length; i++) { bindMobileParent(links[i]); }
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setupMobileParents); } else { setupMobileParents(); }
})();
